import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putColor } from '../Api'

export default generateApiAction({
  baseType: Types.COLORS.PUT,
  api: putColor,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/colors/PutAction.js